import {
  Download,
  Search,
  TrendingUp,
  TrendingDown,
  Minus,
  ChevronUp,
  ChevronDown,
  DollarSign,
  Users,
  Target,
  Award,
} from "lucide-react";

const PerformanceIndicator = ({ current, last }) => {
  const currentVal = Number(current) || 0;
  const lastVal = Number(last) || 0;

  if (lastVal === 0) return <Minus className="w-4 h-4 text-gray-400" />;

  const percentChange = ((currentVal - lastVal) / lastVal) * 100;

  if (percentChange > 5) {
    return (
      <div className="flex items-center gap-1 text-green-600">
        <TrendingUp className="w-4 h-4" />
        <span className="text-xs font-semibold">
          +{percentChange.toFixed(1)}%
        </span>
      </div>
    );
  } else if (percentChange < -5) {
    return (
      <div className="flex items-center gap-1 text-red-600">
        <TrendingDown className="w-4 h-4" />
        <span className="text-xs font-semibold">
          {percentChange.toFixed(1)}%
        </span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-1 text-gray-500">
      <Minus className="w-4 h-4" />
      <span className="text-xs">{percentChange.toFixed(1)}%</span>
    </div>
  );
};

export default PerformanceIndicator;
